import { createRouter, createWebHistory } from 'vue-router';
import Vulnerabilities from '../views/Vulnerabilities.vue';
import Geopolitics from '../views/Geopolitics.vue';
import Cybersecuritynews from '../views/Cybersecuritynews.vue';

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/geopolitics',
    name: 'Geopolitics',
    component: Geopolitics
  },
  {
    path: '/vulnerabilities',
    name: 'Vulnerabilities',
    component: Vulnerabilities
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import('../views/Category.vue')
  },
  {
    path: '/tags',
    name: 'Tags',
    component: () => import('../views/Tags.vue')
  },
  {
    path: '/cybersecuritynews',
    name: 'Cybersecuritynews',
    component: Cybersecuritynews
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
